import { Link } from "react-router-dom";

export default function Header({ right }) {
  return (
    <header
      data-testid="app-header"
      className="h-16 px-4 flex items-center justify-between sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-100"
    >
      <Link to="/" data-testid="header-logo-link" className="flex items-center">
        <img
          src="/logo.jpg"
          alt="Carlos Jr Fretes e Mudanças"
          className="h-12 w-auto object-contain"
          data-testid="header-logo"
        />
      </Link>
      {right}
    </header>
  );
}
